import RunConfigService from "./runConfigService";
import UrlService from "./urlService";
import axios from 'axios';

let THIRTY_MIN = 1000 * 60 * 30;

export default {
    getDowntimeStatus
}

async function getDowntimeStatus() {
    let downtime = await _getDowntime(),
        now = Date.now(),
        retVal = {isDown: false, downInMinutes: -1};

    if (downtime && downtime.downTimeStart && downtime.downTimeEnd) {
        retVal.isDown = now >= downtime.downTimeStart && now < downtime.downTimeEnd;
        if (!retVal.isDown && downtime.downTimeStart < (now - THIRTY_MIN)) {
            retVal.downInMinutes = Math.ceil((downtime.downTimeStart - now) / 1000 / 60);
        }
    }

    return retVal;
}

async function _getDowntime() {
    let runConfig = RunConfigService.getRunConfig(),
        response = await axios({
            url: `${UrlService.getAwsUrl()}/downtime/v1/${runConfig.country}`,
            method: 'GET',
            headers: {
                'client_id': runConfig.clientId,
                'client_secret': runConfig.clientSecret
            }
        });

    return response.data.DowntimeList[0];
}